import React, { useState } from "react";
import { Card } from "@/components/ui/card";
import { FEED_TONE } from "./feedReaderHelpers";

type FeedItemRowCardProps = React.HTMLAttributes<HTMLDivElement> & {
  isRead: boolean;
  isSelected: boolean;
  children: React.ReactNode;
};

export const FeedItemRowCard = React.forwardRef<HTMLDivElement, FeedItemRowCardProps>(
  ({ isRead, isSelected, children, onMouseEnter, onMouseLeave, className, ...rest }, ref) => {
    const [hovered, setHovered] = useState(false);
    return (
      <Card
        ref={ref}
        onMouseEnter={(e) => { setHovered(true); onMouseEnter?.(e); }}
        onMouseLeave={(e) => { setHovered(false); onMouseLeave?.(e); }}
        style={{
          backgroundColor: hovered || isSelected ? FEED_TONE.hover : FEED_TONE.idle,
          borderLeft: `4px solid ${FEED_TONE.accent}`,
        }}
        className={`${isRead ? "opacity-75" : ""} cursor-pointer transition-shadow ${className ?? ""}`}
        {...rest}
      >
        {children}
      </Card>
    );
  },
);
FeedItemRowCard.displayName = "FeedItemRowCard";
